import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    isSubmitting?: boolean;
};

const UserSuperAdminConfirmDialog = ({
    open,
    onOpenChange,
    onConfirm,
    isSubmitting,
}: Props) => {
    const { t } = useTranslation();
    const [confirmText, setConfirmText] = useState('');

    const confirmWord = t('main.superAdmin.users.form.isSuperAdmin.confirmWord');

    const handleConfirm = () => {
        onConfirm();
        setConfirmText('');
        onOpenChange(false);
    };

    const handleOpenChange = (nextOpen: boolean) => {
        if (!nextOpen) {
            setConfirmText('');
        }
        onOpenChange(nextOpen);
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        {t('main.superAdmin.users.form.isSuperAdmin.confirmDialogTitle')}
                    </DialogTitle>
                    <DialogDescription>
                        {t('main.superAdmin.users.form.isSuperAdmin.confirmDialogDescription')}
                    </DialogDescription>
                </DialogHeader>

                <label className="flex flex-col gap-1 text-sm">
                    <span>{t('main.superAdmin.users.form.isSuperAdmin.confirmLabel')}</span>
                    <input
                        type="text"
                        value={confirmText}
                        onChange={(event) => setConfirmText(event.target.value)}
                        className="rounded-lg border border-lightgray bg-base px-3 py-2"
                        placeholder={t('main.superAdmin.users.form.isSuperAdmin.confirmPlaceholder')}
                    />
                </label>

                <DialogFooter>
                    <Button variant="outline" onClick={() => handleOpenChange(false)}>
                        {t('main.superAdmin.users.form.isSuperAdmin.confirmCancel')}
                    </Button>
                    <Button
                        disabled={confirmText !== confirmWord || isSubmitting}
                        onClick={handleConfirm}
                    >
                        {t('main.superAdmin.users.form.isSuperAdmin.confirmSubmit')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default UserSuperAdminConfirmDialog;
